import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import heroBg from '../../assets/images/hero.jpg';
import './Hero.css';

const HeroSection = styled.section`
  min-height: 95vh;
  display: flex;
  align-items: center;
  background: url(${heroBg}) center center/cover no-repeat;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    min-height: 50vh;
    align-items: flex-start;
    padding-top: 70px;
  }
`;

const HeroContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  z-index: 2;
  position: relative;
  height: 95vh;
  justify-content: center;
  padding-top: 100px;

  @media (max-width: 768px) {
    padding: 0 20px;
    height: 50vh;
    padding-top: 80px;
    justify-content: flex-start;
    padding-top: 120px;
  }

  @media (max-width: 480px) {
    padding: 0 15px;
    padding-top: 100px;
  }
`;

const HeroContent = styled.div`
  color: white;
  position: relative;
  z-index: 3;
  margin-left: 0;

  @media (max-width: 768px) {
    margin-left: 0;
    width: 100%;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
`;

const RedBand = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 30px;
  background: #8B0000;
  z-index: 2;
`;

const HeroTitle = styled(motion.h1)`
  font-size: 6rem;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 0.5rem;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 2.5rem;
    line-height: 1.2;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const HeroSubtitle = styled(motion.p)`
  font-size: 2.5rem;
  line-height: 1.4;
  margin-bottom: 1rem;
  opacity: 1;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    line-height: 1.3;
  }

  @media (max-width: 480px) {
    font-size: 1.2rem;
  }
`;

const SeparatorLine = styled(motion.div)`
  width: 100px;
  height: 4px;
  background: white;
  margin: 1.5rem 0;

  @media (max-width: 768px) {
    width: 60px;
    height: 3px;
    margin: 1rem 0;
  }
`;

const Hero = () => {
  return (
    <HeroSection id="home">
      <Overlay />
      <RedBand />
      
      <HeroContainer>
        <HeroContent>
          <HeroTitle
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            City of Windhoek
          </HeroTitle>
          
          <HeroTitle
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1 }}
          >
            Parking
          </HeroTitle>
          
          <SeparatorLine
            initial={{ opacity: 0, scaleX: 0 }}
            animate={{ opacity: 1, scaleX: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          />
          
          <HeroSubtitle
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Smart City.
          </HeroSubtitle>
          
          <HeroSubtitle
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            Smart Parking.
          </HeroSubtitle>
        </HeroContent>
      </HeroContainer>
    </HeroSection>
  );
};

export default Hero; 